import { useEffect, useState } from 'react';
import { DatePicker, DatePickerProps } from '@bamboohr/fabric';
import { NoFacadeComponent } from './no-facade-component';

import { convertDateToIsoFormatString } from './utils';

type SingleDateComponentProps = {
	name: string;
	value?: string;
	noFacade?: boolean;
} & DatePickerProps

export function SingleDateComponent(props: SingleDateComponentProps) {
	const { id, name, value = '', noFacade, ...rest } = props;

	const [selectedDate, setSelectedDate] = useState(convertDateToIsoFormatString(value));
	const [status, setStatus] = useState('')

	const updateStatus = (event: CustomEvent) => {
		if(event.detail.id === id){
			setStatus(event.detail.status)
		}
	}

	useEffect(() => {
		window.addEventListener('updateDatePickerStatus', updateStatus)
		return () => {
		  window.removeEventListener('updateDatePickerStatus', updateStatus)
		}
	}, [])

	return (
		<>
			<DatePicker
				{...rest}
				id={id}
				/**
				 * This is needed to trigger the change event jQuery is listening for when the user selects a date using the calendar picker.
				 */
				onBlur={() => {
					document.getElementById(id).dispatchEvent(new Event('change', { bubbles: true }));
				}}
				onChange={({ value: newSelectedDate }) => {
					setSelectedDate(newSelectedDate);
				}}
				status={status as DatePickerProps['status']}
				value={selectedDate}
			/>
			{noFacade ? (
					<NoFacadeComponent dateString={selectedDate} name={name} />
			) : (
				''
			)}
		</>
	);
}
